module.exports = __webpack_public_path__ + "img/egg_crowns_happy.21899344.svg";